<template>
	<AppLayout :title="trans('menu.home')">
		<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
			<Card v-for="data in homeData" :title="data.title" :subtitle="data.subtitle">
				<BarChart v-if="data.type === 'bar'" :chart-data="data.data"/>
				<LineChart v-else :chart-data="data.data"/>
			</Card>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import Card from '@/Components/UI/Cards/Card.vue'
import {BarChart, LineChart} from 'vue-chart-3'
import AppLayout from '@/Layouts/AppLayout.vue'
import {Chart, type ChartData, registerables} from 'chart.js'

Chart.register(...registerables)

defineProps<{
	homeData: Array<{
		title:string,
		subtitle:string,
		type:'bar'|'line',
		data: ChartData<'bar'|'line',Array<number>>,
	}>,
}>()
</script>